import { piecesValidation } from "../helpers/multipleAddonsHelper";
import { MultiOrderItem } from "../types/items";

type Validation = {
  hasError?: boolean;
  hasWarning?: boolean;
  message: string;
};
export type SelectedItem = {
  validation: Validation;
  availableStock?: number;
  name?: string;
} & Partial<MultiOrderItem>;

export type SelectedItems = Record<number, SelectedItem>;

type SelectItemAction = {
  type: "SELECT_ITEM";
  payload: {
    index: number;
    availableStock?: number;
    item: { name: string } & MultiOrderItem;
  };
};

type ChangePiecesAction = {
  type: "CHANGE_PIECES";
  payload: {
    index: number;
    pieces: string;
  };
};

type ClearInputAction = {
  type: "CLEAR_INPUT";
  payload: {
    index: number;
    pieces: string;
  };
};

type ResetItemsAction = {
  type: "RESET_ITEMS";
};

export type SelectedItemsAction =
  | SelectItemAction
  | ChangePiecesAction
  | ClearInputAction
  | ResetItemsAction;

const selectedItemsReducer = (
  state: SelectedItems,
  action: SelectedItemsAction
): SelectedItems => {
  switch (action.type) {
    case "SELECT_ITEM": {
      const { index, item, availableStock } = action.payload;
      if (index in state) {
        const newState = { ...state };
        delete newState[index];
        return newState;
      } else {
        return {
          ...state,
          [index]: {
            ...item,
            selectedPieces: item.lastRefilledQuantity.toString(),
            validation: piecesValidation(
              item.lastRefilledQuantity.toString(),
              item.maxAmount,
              availableStock
            ),
          },
        };
      }
    }
    case "CHANGE_PIECES": {
      const { index, pieces } = action.payload;
      const selectedItem = state[index];
      if (!selectedItem) return state;
      return {
        ...state,
        [index]: {
          ...selectedItem,
          selectedPieces: pieces,
          validation: piecesValidation(
            pieces,
            selectedItem.maxAmount,
            selectedItem.availableStock
          ),
        },
      };
    }
    case "CLEAR_INPUT": {
      const { index } = action.payload;
      const selectedItem = state[index];
      if (!selectedItem) return state;
      return {
        ...state,
        [index]: {
          ...selectedItem,
          selectedPieces: "",
          validation: piecesValidation("", selectedItem.maxAmount),
        },
      };
    }
    case "RESET_ITEMS": {
      return {};
    }
    default:
      return state;
  }
};

export default selectedItemsReducer;
